import React, { FC } from 'react';
import Color from 'color';
import { createMuiTheme, CssBaseline, ThemeProvider } from '@material-ui/core';
import createSpacing from '@material-ui/core/styles/createSpacing';

export const AppTheme: FC = (props) => {
    return (
        <ThemeProvider theme={SSMTheme}>
            <CssBaseline/>
            {props.children}
        </ThemeProvider>
    );
};
const SSMSpacing = createSpacing(8);
const mainColor = Color('#02436d');

export const SSMPalette = {
    primary: {
        mainOrange: '#f18700',
        main: mainColor.hex(),
        dark: mainColor.darken(.25).hex(),
        light: mainColor.lighten(.25).hex(),
        disabled: mainColor.mix(Color('#fff')).lighten(.07).hex(),
        disabledText: mainColor.mix(Color('#fff')).lighten(.5).hex(),
    },
    gray: {
        graphite: '#333',
        dark: '#666',
        fossil: '#a6a6a6',
        silver: '#bababa',
        iron: '#707e85',
        linen: '#f3f3f3',
        sand: '#e6e3e0',
        alabaster: '#fff',
    },
    common: {
        white: '#fff',
        black: '#000',
        chart: '#767676',
    },
    charts: {
        winding: '#009900',
        windingSecond: '#80CC80',
        doffing: '#00BB00',
        doffingSecond: '#80DD80',
        stop: '#948B7E',
        stopSecond: '#bfb9b2',
        noYarn: '#FF7700',
        noYarnSecond: '#FFBB80',
        warning: '#880000',
        warningSecond: '#C48080',
        error: '#FF0000',
        errorSecond: '#FF8080',
        service: '#00aaaa',
        serviceSecond: '#80D5D5',
        unknown: '#878787',
        unknownSecond: '#B1B0B0',
        new: '#ffbf01',
        newSecond: '#ffdc76',

        record_1: '#1C3A70',
        record_2: '#4372C4',
        record_3: '#5698D4',
        record_4: '#ED7D30',
        record_5: '#FFBF01',
        record_6: '#6DAB44',
        record_7: '#9F4B12',
    }
};
const SSMTheme = createMuiTheme({
    palette: {
        primary: SSMPalette.primary,
        text: {
            primary: SSMPalette.gray.iron,
            disabled: SSMPalette.gray.fossil,
        },
        background: {
            default: SSMPalette.common.white,
        }
    },
    typography: {
        fontSize: 16,
        fontFamily: 'Noto Sans, Roboto, sans-serif'
    },
    overrides: {
        MuiTouchRipple: {
            root: {
                display: 'none',
            }
        },
        MuiButton: {
            text: {
                padding: SSMSpacing(1, 1.5),
                lineHeight: 1.3,
                textTransform: 'none'
            },
            startIcon: {
                fontSize: 1.2,
            },
            iconSizeMedium: {
                margin: SSMSpacing(-.75, .75, -.75, -.75),
                '& > *:first-child': {
                    fontSize: 26
                }
            },
            root: {
                borderRadius: 4,
                backgroundColor: SSMPalette.gray.sand,
                color: SSMPalette.gray.graphite,
                minWidth: SSMSpacing(4.5),
                '&:hover': {
                    backgroundColor: SSMPalette.gray.linen,
                    color: SSMPalette.gray.graphite,
                },
                '&:active': {
                    backgroundColor: SSMPalette.gray.iron,
                    color: SSMPalette.gray.graphite,
                },
                '&:disabled': {
                    backgroundColor: SSMPalette.gray.alabaster,
                    color: SSMPalette.gray.fossil,
                },
            },
            textPrimary: {
                color: SSMPalette.common.white,
                backgroundColor: SSMPalette.primary.light,
                '&:hover': {
                    backgroundColor: SSMPalette.primary.main,
                    color: SSMPalette.common.white,
                },
                '&:active': {
                    backgroundColor: SSMPalette.primary.dark,
                    color: SSMPalette.common.white,
                },
                '&:disabled': {
                    backgroundColor: SSMPalette.primary.disabled,
                    color: SSMPalette.primary.disabledText,
                },
            }
        },
        MuiIconButton: {
            root: {
                borderRadius: 4,
                padding: SSMSpacing(.625),
                backgroundColor: SSMPalette.gray.sand,
                color: SSMPalette.gray.graphite,
                '&:hover': {
                    backgroundColor: SSMPalette.gray.linen,
                    color: SSMPalette.gray.graphite,
                },
                '&:active': {
                    backgroundColor: SSMPalette.gray.iron,
                    color: SSMPalette.gray.graphite,
                },
                '&:disabled': {
                    backgroundColor: SSMPalette.gray.alabaster,
                    color: SSMPalette.gray.fossil,
                },
            },
            colorPrimary: {
                color: SSMPalette.common.white,
                backgroundColor: SSMPalette.primary.light,
                '&:hover': {
                    backgroundColor: SSMPalette.primary.main,
                    color: SSMPalette.common.white,
                },
                '&:active': {
                    backgroundColor: SSMPalette.primary.dark,
                    color: SSMPalette.common.white,
                },
                '&:disabled': {
                    backgroundColor: SSMPalette.primary.disabled,
                    color: SSMPalette.primary.disabledText,
                },
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: 26
            }
        }
    },
});
